import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Grid,
  Button,
  Link
} from '@mui/material';
import axios from "axios";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import './help.css'
const helpData = [//AtX-yPS0INE
  {
    question: "General Video عمومی ویډیو",
    answer: 'دا یوازې یوه ویډیو ده او پدې ویډیو کې موږ د ټول ډیټابیس په اړه یو څه عمومي پوهه ورکړې ده، مهرباني وکړئ لومړی دا وګورئ.',
    id: 'AtX-yPS0INE',
    videoId: "GeneralVideo.mp4" // Linked video ID
  },
  {
    question: "Dashboard ډشبورډ",
    answer: "پدې ویډیو کې تاسو کولی شئ پلور وکړئ، پیرودونکي ته بل تولید کړئ او همدارنګه پیرودونکي په لیست کې اضافه کړئ، بل په پور او نغدو پیسو ترسره کیدی شي، تاسو کولی شئ بل چاپ کړئ یا د واټس اپ له لارې د پیرودونکي شمیرې ته واستوئ.",
    id: "C",
    videoId: "Dashboard.mp4" 
  },
  {
    question: "Refund بیرته ستنیدل",
    answer: "کله چې مشتری اړتیا ولري چې د رانیول سوي توکي یا توکو بیرته واپس راوړي، نو مونږ جنس په بدل کی د بل په حساب مشتری ته نغدی ورکوو او که پر مشتری باندی پور باندي وی نو په پور کی مجرا کولای سو",
    id: "C",
    videoId: "Refund.mp4" 
  },
  {
    question: "Receipt رسید",
    answer: "په دې ویډیو کې تاسو لیدلی سئ چې د پیرودونکو څومره بیلونه تولید سوي او د هر ریکارډ په کلیک کولو سره به تاسو جوړ سوی بل کتلای سی.",
    id: '',
    videoId: "Receipt.mp4"
  },
  {
    question: "Daily Cash روزنامچه",
    answer: "دخل کی سونه کیش موجود دی ، د نغدو پیسو هره ورځ د ننوتلو یا وتلو معامله به په روزنامچه کې ښودل کیږی، ",
    id: "C",
    videoId: "Roznamcha.mp4" 
  },
  {
    question: "Expenses مصارف",
    answer: "پدې ویډیو کې تاسو ورځني لګښتونه راټولوئ او خوندي کوئ",
    id: "C",
    videoId: "Expenses.mp4" 
  },
  {
    question: "Customer Account مشتری کهاته",
    answer: "د مشتری کهاته، موږ کولای سو د مشتری د تعاملاتو بشپړ تفصیل وګورو، څومره بیلونه تولید سوي که د نغدي یا پور یا هم بیرته راستنیدنه وی، موږ بشپړ ریکارډ لرو. او پدې برخه کې د پور بیرته ترلاسه کولو لپاره نغدي پیسې هم ترلاسه کوو.",
    id: "PebH4J6sPPk",
    videoId: "CustomerAccount.mp4" 
  },
  {
    question: "Purchase خرید",
    answer: "د راجستر شوي عرضه کوونکي څخه په نغدو پیسو، پور یا نغدي پور دواړو کې خرید کولای سی. محصولات نوي هم کیدای سي اوپه موجوده کی اضافه هم کیدای سي، د خرید قیمت، مقدار، د خرڅ قیمت، د هر محصول عکس، بارکوډ، برانډ، کټګوري او توضیحات ثبت کیږی، ",
    id: "C",
    videoId: "Purchase.mp4" 
  },
  {
    question: "Purchase Brand Category خرید براند کټيګوري",
    answer: "پدې ویډیو کې تاسو لیدلی شئ چې څنګه برانډونه او کټګورۍ اضافه کړئ",
    id: '',
    videoId: "Brand-Category.mp4" 
  },
  {
    question: "Product جنس",
    answer: "د جنس په اړه بشپړ معلومات. له چا څخه رانیلوی دی، څومره مقدار، په کوم قیمت،پلورل شوي مقدار،  پاته مقدار  دی،  د نرخ بدلون، ورکړل شوی تخفیف، او ډیر نور. همدارنګه موږ کولی شو پدې برخه کې د جنس قیمت بدل کړو.",
    id: "7g2fNiAft7M",
    videoId: "Product.mp4" 
  },
  {
    question: "Supplier عرضه کوونکی",
    answer: "د عرضه کوونکي لیست وګورئ، د تلیفون شمیره یا د عرضه کوونکي نوم هم لټولی سئ. او همدارنګه عرضه کوونکی اضافه کولی سئ",
    id: "mnq6it_vbIM",
    videoId: "Supplier.mp4" 
  },
  {
    question: "Supplier Account عرضه کوونکي کهاته",
    answer: "په دې برخه کې، موږ کولی سو د هر عرضه کوونکي د کهاته په تفصیل سره وګورو، څونه بلون په نغدو پیسو او پور څونه بیلونه تولید سوي. څومره توکی بیرته واپس کړی دی او موږ څونه پوروړي یو. موږ کولی سو پدې برخه کې پور هم ادا کړو.",
    id: "C",
    videoId: "SupplierAccount.mp4" 
  },
  {
    question: "Return عرضه کوونکی ته واپس",
    answer: "پدې برخه کې به موږ ځانګړی جنس عرضه کوونکي ته د نیمګړتیا یا کوم دلیل په صورت کې بیرته ورکړو.",
    id: "C",
    videoId: "ReturnSupplier.mp4" 
  },
  {
    question: "Capital Add پانګونه",
    answer: "پدې برخه کې موږ کولای سو د هر شریک لخوا پانګونه وکړو. او موږ کولای سو تر وسه د ترسره سوي پانګونې وګورو.",
    id: "VU6adQhI4qk",
    videoId: "UserCapitalAdd.mp4" 
  },
  {
    question: "Capital Remove د پانګی خروج",
    answer: "پدې برخه کې موږ کولای سو د هر شریک لخوا پانګونه لیری کړو. او موږ کولای سو تر وسه د ترسره سوي پانګونې وګورو.",
    id: "nP7reITxWPo",
    videoId: "CapitalRemove.mp4" 
  },
  {
    question: "Salary معاش او اډوانس",
    answer: "پدې برخه کې، موږ کولی شو هر کارګر ته مخکې اډوانس/معاش ورکړو او د هر کارګر د معاش او اډوانس بشپړه ریکارډ هم وګورو.",
    id: "C",
    videoId: "Salary1.mp4" 
  },
  {
    question: "Finance مالیه",
    answer: "په مالي برخه کې تاسو کولی شئ وګورئ چې ستاسو د سوداګرۍ فعالیت څنګه دی، څومره محصولات پاتې دي، ټول لګښت، د پیرودونکو پور چې دوی موږ ته پوروړی دی، د عرضه کونکي پور چې موږ یې پوروړی یو، ټول پلور، موجوده موجودي توکي، او ډیر نور.",
    id: '',
    videoId: "Finance.mp4" // Linked video ID
  },
  // {
  //   question: "Refund بیرته ستنیدل",
  //   answer: "کله چې مشتری اړتیا ولري چې د رانیول سوي توکي یا توکو بیرته واپس راوړي، نو مونږ جنس په بدل کی د بل په حساب مشتری ته نغدی ورکوو او که پر مشتری باندی پور باندي وی نو په پور کی مجرا کولای سو",
  //   id: "C",
  //   videoId: "Brand-Category.mp4" 
  // },
  
  {
    question: "Barcode بارکوډ",
    answer: "پدې برخه کې، موږ کولای سو نوی بارکوډ لیبل تولید کړو، موږ کولی سو بارکوډ ډیلیټ کړو او همدارنګه د هر جنس لپاره بارکوډ اپډیټ کړو.",
    id: "Ldo1Duqa8Z4",
    videoId: "Barcod.mp4" 
  },
  {
    question: "System Settings سیسټم ترتیبات",
    answer: "پدې برخه کې تاسو کولای سئ ملګری، مدیر، کارګر او پلورونکی اضافه کړئ.",
    id: "w12qogVcJ14",
    videoId: "SystemSettings.mp4" 
  },
  {
    question: "Backup بیک اپ",
    answer: "پدې برخه کې تاسو بیک اپ اخلئ او په خپل کمپیوټر یا USB کې یې خوندي کوئ",
    id: "w12qogVcJ14",
    videoId: "Barcod.mp4" 
  },
  // {
  //   question: "",
  //   answer: "C",
  //   id: "C",
  //   videoId: "Category.mp4" 
  // },
];

     
const HelpComponent = () => {
  const [search, setSearch] = useState("");
  const [videoLinks, setVideoLinks] = useState([])
  const fetchVideoTutorials = async () => {
    const registerd = JSON.parse(localStorage.getItem("Registered")) || undefined;
    //console.log(registerd)
    try {
        const response = await axios.get(`https://roznamchaback.wasily.net/videoslinks?phone=0703131865`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${registerd}`,
            },
        });
        if (response.status === 200) {
            //console.log("Fetched Video Tutorials:", response.data.data);
            setVideoLinks(response?.data?.data)
        }
    } catch (err) {
        console.error("Error fetching video tutorials:", err);
    }
};

useEffect(() => {
    fetchVideoTutorials()
    }, []);

  const filteredHelp = helpData.filter(item =>
    item.question.toLowerCase().includes(search.toLowerCase()) ||
    item.answer.toLowerCase().includes(search.toLowerCase())
  );

  const filteredVideos = videoLinks.filter(video =>
    video.title.toLowerCase().includes(search.toLowerCase()) ||
    helpData.some(faq => 
      faq.videoId === video.youtube && 
      (faq.question.toLowerCase().includes(search.toLowerCase()) ||
      faq.answer.toLowerCase().includes(search.toLowerCase()))
  ));

    // const openVideoInNewWindow = (videoFile) => {
    // // Path to videos in your Electron app's resources folder
    //   const videoPath = `file://${window.electron.getVideoPath(videoFile)}`;
      
    //   // Open in a new window with video player
    //   const videoWindow = window.open('', '_blank', 
    //   `width=800,height=600,top=100,left=100`
    //   );
    // }
  const openVideoInNewWindow = (videoId) => {
    const videoUrl = `https://www.youtube.com/watch?v=${videoId}`;
    window.open(videoUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Box sx={{ padding: 4, maxWidth: '1200px', margin: 'auto' }} className='helping'>
      <Typography variant="h4" align="center" gutterBottom>
        د مرستې مرکز او لارښوونې
      </Typography>

      <TextField
        fullWidth
        label="د مرستې موضوعاتو لټون..."
        variant="outlined"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 4 }}
        style={{direction:'rtl'}}
      />

      <Grid container spacing={4}>
        {/* Tutorial Videos Section */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              {/* <Typography variant="h6" gutterBottom>
                Tutorial Videos
              </Typography> */}
              {filteredVideos.map((video, index) => (
                <Box key={index} sx={{ mb: 3 }}>
                  <iframe
                    width="100%"
                    height="215"
                    src={`https://www.youtube.com/embed/${video.youtube}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                  <Typography variant="subtitle1" sx={{ mt: 1 }} className='helping'>
                    {video.title}
                  </Typography>
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>

        {/* FAQs Section */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                په مکرر ډول پوښتل سوي پوښتنې
              </Typography>
              {filteredHelp.map((item, index) => (
                <Accordion key={index}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>{item.question}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography  style={{direction:'rtl', fontSize: '16px'}}>{item.answer}</Typography>
                    {item.videoId && (
                      <Box sx={{ mt: 2 }}>
                        {/* <Button
                          variant="outlined"
                          startIcon={<PlayCircleOutlineIcon />}
                          onClick={() => openVideoInNewWindow(item.videoId)}
                          sx={{ mt: 1 }}
                        > 
                        </Button> */}
                        {/* <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                          Click to open in YouTube
                        </Typography> */}
                      </Box>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HelpComponent;